{
  "customers.title": "Customers",
  "customers.description": "Find and maintain customer records, then open Customer 360 for the service context you can access.",
  "customers.directory": "Customer directory",
  "customers.new": "New customer",
  "customers.refresh": "Refresh",
  "customers.refreshingList": "Refreshing customer list",
  "customers.clearSearch": "Clear search",
  "customers.clearFilters": "Clear filters",
  "customers.searchLabel": "Search customers",
  "customers.searchPlaceholder": "Search name, phone, email, or business ID…",
  "customers.loadingList": "Loading customers…",
  "customers.empty.filteredTitle": "No matching customers",
  "customers.empty.filteredDetail": "Try another keyword or clear the current search.",
  "customers.empty.title": "No customers yet",
  "customers.empty.detail": "Create your first customer to manage profiles and service history in one place.",
  "customers.paginationLabel": "customers",
  "customers.unnamed": "Unnamed customer",
  "customers.noAdditionalInfo": "No additional details",
  "customers.notRecorded": "Not recorded",
  "customers.notBound": "Not linked",
  "customers.actions": "Actions",
  "customers.customerActions": "Actions for {name}",
  "customers.view360": "View Customer 360",
  "customers.editContact": "Edit contact details",
  "customers.emptyTable": "No customers",
  "customers.table.customer": "Customer",
  "customers.table.contact": "Contact details",
  "customers.table.businessBinding": "Business identity",
  "customers.table.updatedAt": "Last updated",
  "customers.table.profileUpdated": "Profile updated",
  "customers.table.created": "Customer created",
  "customers.sort.createdAt": "Created",
  "customers.sort.updatedAt": "Last updated",
  "customers.sort.name": "Customer name",
  "customers.sort.phone": "Phone",
  "customers.sort.email": "Email",
  "customers.form.editTitle": "Edit customer",
  "customers.form.createTitle": "New customer",
  "customers.form.editDescription": "Update the customer's basic contact details. The trusted business identity is managed elsewhere.",
  "customers.form.createDescription": "Enter the customer's basic details. Provide at least one of name, phone, or email.",
  "customers.form.emptyTitle": "Customer details are required",
  "customers.form.name": "Name",
  "customers.form.phone": "Phone",
  "customers.form.email": "Email",
  "customers.form.namePlaceholder": "For example, Alex Chen",
  "customers.form.phonePlaceholder": "For example, +1 555 0100",
  "customers.form.emailPlaceholder": "For example, customer@example.com",
  "customers.form.cancel": "Cancel",
  "customers.form.saving": "Saving customer",
  "customers.form.save": "Save customer",
  "customers.form.create": "Create customer",
  "customers.validation.oneContactRequired": "Provide at least one of name, phone, or email.",
  "customers.validation.nameTooLong": "Customer name cannot exceed {count} characters.",
  "customers.validation.phoneTooLong": "Phone number cannot exceed {count} characters.",
  "customers.validation.emailTooLong": "Email cannot exceed {count} characters.",
  "customers.validation.invalidEmail": "Enter a valid email address.",
  "customers.createdToast": "Customer “{name}” was created.",
  "customers.savedToast": "Customer “{name}” was saved.",
  "customers.detail.fallbackTitle": "Customer 360",
  "customers.detail.returnToCustomer": "Back to customer",
  "customers.detail.returnToTicket": "Back to ticket",
  "customers.detail.backToList": "Back to customers",
  "customers.detail.refreshing": "Refreshing Customer 360",
  "customers.detail.description": "View the customer's identity, contact details, and service history available within your access scope.",
  "customers.detail.loading": "Loading Customer 360…",
  "customers.detail.serviceRecords": "Customer service history",
  "customers.profile.identityLinked": "Trusted business identity linked",
  "customers.profile.identityNotLinked": "No trusted business identity linked",
  "customers.profile.edit": "Edit profile",
  "customers.profile.contact": "Contact details",
  "customers.profile.phone": "Phone",
  "customers.profile.email": "Email",
  "customers.profile.businessId": "Business identity",
  "customers.profile.noBusinessId": "No user identifier verified by a trusted business system is linked.",
  "customers.profile.extended": "Extended details",
  "customers.profile.noExtendedTitle": "No extended details",
  "customers.profile.noExtendedDetail": "Read-only details supplied by an external business system will appear here.",
  "customers.profile.createdAt": "Created {date}",
  "customers.profile.updatedAt": "Last updated {date}",
  "customers.service.loading": "Loading customer service history…",
  "customers.service.hiddenTitle": "Service history is hidden",
  "customers.service.hiddenDetail": "You can view this customer profile, but you do not have permission to view tickets. Service metrics and ticket history will not be requested or shown.",
  "customers.service.errorTitle": "Could not load service history",
  "customers.service.errorDetail": "The customer profile is still available. Try loading the tickets in your access scope again.",
  "customers.service.retry": "Retry",
  "customers.service.refreshing": "Refreshing service history",
  "customers.service.refreshingShort": "Refreshing",
  "customers.service.ticketPaginationLabel": "tickets",
  "customers.metrics.title": "Service overview",
  "customers.metrics.description": "Linked ticket metrics visible within your current access scope.",
  "customers.metrics.total": "Total tickets",
  "customers.metrics.totalDetail": "Linked tickets visible in your access scope",
  "customers.metrics.active": "In progress",
  "customers.metrics.activeDetail": "Not yet resolved or closed",
  "customers.metrics.resolved": "Resolved",
  "customers.metrics.resolvedDetail": "Resolved and closed tickets",
  "customers.metrics.recent": "Latest service",
  "customers.metrics.noRecent": "No activity",
  "customers.metrics.recentDetail": "Most recent ticket activity",
  "customers.tickets.title": "Recent tickets",
  "customers.tickets.description": "Tickets linked to this customer, ordered by most recent update.",
  "customers.tickets.ticket": "Ticket",
  "customers.tickets.status": "Status",
  "customers.tickets.priority": "Priority",
  "customers.tickets.project": "Project",
  "customers.tickets.assignee": "Assignee",
  "customers.tickets.updatedAt": "Last updated",
  "customers.tickets.unspecifiedProject": "No project",
  "customers.tickets.unassigned": "Unassigned",
  "customers.tickets.viewAll": "View all",
  "customers.tickets.empty": "This customer has no linked tickets"
}
